import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { cn } from "$lib/utils.js";

var root = $.from_html(`<div><!></div>`);

export default function Card_footer($$anchor, $$props) {
	$.push($$props, true);

	let ref = $.prop($$props, 'ref', 15, null),
		restProps = $.rest_props($$props, [
			'$$slots',
			'$$events',
			'$$legacy',
			'ref',
			'class',
			'children'
		]);

	var div = root();

	$.attribute_effect(div, ($0) => ({ 'data-slot': 'card-footer', class: $0, ...restProps }), [
		() => cn("flex items-center px-6 [.border-t]:pt-6", $$props.class)
	]);

	var node = $.child(div);

	$.snippet(node, () => $$props.children ?? $.noop);
	$.reset(div);
	$.bind_this(div, ($$value) => ref($$value), () => ref());
	$.append($$anchor, div);
	$.pop();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiY2FyZC1mb290ZXIuc3ZlbHRlIl0sInNvdXJjZXNDb250ZW50IjpbIjxzY3JpcHQgbGFuZz1cInRzXCI+XG5cdGltcG9ydCB7IGNuLCB0eXBlIFdpdGhFbGVtZW50UmVmIH0gZnJvbSBcIiRsaWIvdXRpbHMuanNcIjtcblx0aW1wb3J0IHR5cGUgeyBIVE1MQXR0cmlidXRlcyB9IGZyb20gXCJzdmVsdGUvZWxlbWVudHNcIjtcblxuXHRsZXQge1xuXHRcdHJlZiA9ICRiaW5kYWJsZShudWxsKSxcblx0XHRjbGFzczogY2xhc3NOYW1lLFxuXHRcdGNoaWxkcmVuLFxuXHRcdC4uLnJlc3RQcm9wc1xuXHR9OiBXaXRoRWxlbWVudFJlZjxIVE1MQXR0cmlidXRlczxIVE1MRGl2RWxlbWVudD4+ID0gJHByb3BzKCk7XG48L3NjcmlwdD5cblxuPGRpdlxuXHRiaW5kOnRoaXM9e3JlZn1cblx0ZGF0YS1zbG90PVwiY2FyZC1mb290ZXJcIlxuXHRjbGFzcz17Y24oXCJmbGV4IGl0ZW1zLWNlbnRlciBweC02IFsuYm9yZGVyLXRdOnB0LTZcIiwgY2xhc3NOYW1lKX1cblx0ey4uLnJlc3RQcm9wc31cbj5cblx0e0ByZW5kZXIgY2hpbGRyZW4/LigpfVxuPC9kaXY+XG4iXSwibWFwcGluZ3MiOiI7O1NBQ1UsRUFBRSxRQUE2QixlQUFlOzs7O3VEQUR4RCxDQUFDOzs7S0FLQyxHQUFHLDhCQUFhLElBQUk7RUFHakIsU0FBUzs7Ozs7Ozs7Ozs7OEVBUVQsU0FBUztRQUROLEVBQUUsQ0FBQyx5Q0FBeUM7Ozs7Ozs7K0JBRnhDLEdBQUcsaUJBQUgsR0FBRzs7O0FBSGhCLENBQUMifQ==